'use client';
import React from 'react';
import {Box, Stack} from '@mui/material';
import Image from 'next/image';
import {ImageObj} from '@custom-types/ImageObj.types';
import CustomCarousel from '@components/CustomCarousel';
import {Mobile} from '@components/Mobile';
import {Desktop} from '@components/Desktop';
import cn from './style.module.scss';

interface WaldorfDistinctiveSliderProps {
  t: any;
  distinctiveMobileSlideImage: Array<ImageObj>;
  distinctiveDesktopSlideImage: Array<ImageObj>;
}
const slickSettings = {
  dots: false,
  arrows: false,
  fade: true,
  autoplay: true,
  infinite: true,
  speed: 1000,
  autoplaySpeed: 8000,
  slidesToScroll: 1,
  slidesToShow: 1,
  initialSlide: 1,
  centerMode: false,
  touchMove: false,
  focusOnSelect: true,
  pauseOnHover: false,
};
export default function WaldorfDistinctiveSlider(
  props: WaldorfDistinctiveSliderProps
) {
  const {t} = props;
  return (
    <Box component='section' className={cn.waldorfDistinctive}>
      <Stack className={cn.distinctiveInner}>
        <Box className={cn.distinctiveElement}>
          <Mobile>
            <CustomCarousel {...slickSettings} className='orientalSlider'>
              {props.distinctiveMobileSlideImage.map((image, index) => (
                <picture key={index} className={cn.distinctiveStory}>
                  <Image
                    src={image.url}
                    alt='image'
                    layout='responsive'
                    width={600}
                    height={400}
                    unoptimized
                    quality={100}
                  />
                </picture>
              ))}
            </CustomCarousel>
          </Mobile>
          <Desktop>
            <CustomCarousel {...slickSettings} className='orientalSlider'>
              {props.distinctiveDesktopSlideImage.map((image, index) => (
                <picture key={index} className={cn.distinctiveStory}>
                  <Image
                    src={image.url}
                    alt='image'
                    layout='responsive'
                    width={600}
                    height={400}
                    unoptimized
                    quality={100}
                  />
                </picture>
              ))}
            </CustomCarousel>
          </Desktop>
        </Box>
      </Stack>
    </Box>
  );
}
